import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../../assets/images/Property_owner_preview-1.png'
import _imports_1 from '../../../../assets/images/Property_owner_preview-2.png'
import _imports_2 from '../../../../assets/images/Property_owner_preview-3.png'
import _imports_3 from '../../../../assets/images/Property_owner_preview-4.png'
import _imports_4 from '../../../../assets/images/Property_owner_preview-5.png'
import _imports_5 from '../../../../assets/images/Property_owner_preview-6.png'


const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Tutorial", -1)
const _hoisted_4 = { class: "modal_form" }
const _hoisted_5 = {
  key: 0,
  class: "modal__carousel__content"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "modal__image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Add a Property", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "modal__carousel__content"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "modal__image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Raise an Issue", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "modal__carousel__content"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "modal__image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Post a Project", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  class: "modal__carousel__content"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "modal__image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Out of Hours", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 4,
  class: "modal__carousel__content"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "modal__image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Documents", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 5,
  class: "modal__carousel__content"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "modal__image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Calendar", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "modal__navigation__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_PropertyOwnerSubscriptionModal = _resolveComponent("PropertyOwnerSubscriptionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonDialog, {
      isShowHeader: false,
      isShowBackButton: false,
      className: [
      'create_workstation_preview_modal create_workstation_preview_modal_new',
    ],
      width: "590px",
      height: "auto"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_v_btn, {
              icon: "mdi-close",
              onClick: $setup.onClickClosePreviewButton
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            ($setup.currentSelectedTab?.id == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id == 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
              : _createCommentVNode("", true),
            ($setup.currentSelectedTab?.id == 6)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_v_btn, {
            class: _normalizeClass(["button md:!tw-w-full", $setup.isDisablePrevious ? 'disable' : 'button-purple-border']),
            disabled: $setup.isDisablePrevious,
            onClick: $setup.goToPreviousTab
          }, {
            default: _withCtx(() => [
              _createTextVNode("Previous")
            ]),
            _: 1
          }, 8, ["disabled", "class", "onClick"]),
          _createVNode(_component_v_btn, {
            class: "button button-orange md:!tw-w-full",
            onClick: $setup.goToNextTab
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.currentSelectedTab.id == 6 ? "Go To Dashboard" : "Next"), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_v_stepper, {
          class: "onboard-stepper",
          modelValue: $setup.currentSelectedTab.id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.currentSelectedTab.id) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modelDetails, (step) => {
                  return (_openBlock(), _createBlock(_component_v_stepper_item, {
                    class: _normalizeClass(["onboard-stepper__item", { done: $setup.currentSelectedTab.id > step?.id }]),
                    key: step?.id,
                    title: step?.tab,
                    value: step?.id
                  }, null, 8, ["class", "title", "value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    ($setup.isShowSubscriptionModal)
      ? (_openBlock(), _createBlock(_component_PropertyOwnerSubscriptionModal, {
          key: 0,
          onCloseSubscriptionModal: $setup.onClickCloseButton,
          onCloseSelectWorkstationTypeModal: $setup.onClickCloseButton
        }, null, 8, ["onCloseSubscriptionModal", "onCloseSelectWorkstationTypeModal"]))
      : _createCommentVNode("", true)
  ], 64))
}